import cntl from "cntl";
import PropTypes from "prop-types";
import { IconStar, IconStarHalf } from "@tabler/icons-react";

const proptypes = {
  isHalf: PropTypes.bool,
  isFull: PropTypes.bool,
};
const ReviewStar = ({ isHalf, isFull }) => {
  const starWrapperCn = () => cntl`
    relative
    flex-inline
    overflow-hidden
  `;

  const greyStarCn = () => cntl`
    fill-gray-light-6
    text-gray-light-6
  `;

  const halfStarCn = () => cntl`
    -ml-px
    inset-0
    right-0
    absolute
    fill-warning-light-10
    text-warning-light-10
  `;

  const fullStarCn = () => cntl`
    inset-0
    right-0
    absolute
    fill-warning-light-10
    text-warning-light-10
  `;

  return (
    <div className={starWrapperCn()}>
      <IconStar className={greyStarCn()} />
      {isHalf && <IconStarHalf className={halfStarCn()} />}
      {isFull && <IconStar className={fullStarCn()} />}
    </div>
  );
};

ReviewStar.prototype = proptypes;
export default ReviewStar;
